import React from 'react';
import { AcademicCapIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '../../contexts/LanguageContext';
import SettingsModuleRedirect from './SettingsModuleRedirect';

const CourseSettings = () => {
  const { t } = useLanguage();

  return (
    <SettingsModuleRedirect
      icon={AcademicCapIcon}
      title={t('settingsPage.coursesRedirectTitle')}
      description={t('settingsPage.coursesRedirectDesc')}
      linkTo="/courses"
      linkLabel={t('settingsPage.coursesRedirectLink')}
      noticeTitle={t('settingsPage.moduleRedirectNoticeTitle')}
      noticeBody={t('settingsPage.coursesRedirectNotice')}
      bullets={[
        t('settingsPage.coursesBullet1'),
        t('settingsPage.coursesBullet2'),
        t('settingsPage.coursesBullet3'),
      ]}
    />
  );
};

export default CourseSettings;
